import {
  IconDashboard,
  IconOrders,
  IconProducts,
  IconCurrencyDollarCircle,
  IconCog,
} from '@hubii/icons';

export const generateTestId = (dataTestId: string) => ({
  component: dataTestId,
  sidebar: `${dataTestId}-sidebar`,
  tab: `${dataTestId}-tab`,
});

export const data = {
  navItems: [
    {
      label: 'Dashboard',
      url: '/desempenho',
      icon: IconDashboard,
      isActive: false,
    },
    {
      label: 'Pedidos',
      url: '/pedidos',
      icon: IconOrders,
      isActive: false,
    },
    {
      label: 'Produtos',
      url: '/produtos',
      icon: IconProducts,
      isActive: false,
    },
    {
      label: 'Financeiro',
      url: '/financeiro',
      icon: IconCurrencyDollarCircle,
      isActive: false,
    },
    {
      label: 'Configurações',
      url: '/conta',
      icon: IconCog,
      isActive: false,
    },
  ],
  terms: {
    owner: {
      warning: (date: string) =>
        `<strong>Até ${date}</strong> leia e aceite os termos de adesão enviado via email. Não se preocupe, as regras de desempenho, pedidos e financeiras praticadas até agora continuam as mesmas.`,
      last_days: (date: string) =>
        `<strong>Até ${date}</strong> leia e aceite os termos de adesão enviado via email. Não se preocupe, as regras de desempenho, pedidos e financeiras praticadas até agora continuam as mesmas`,
      last_day:
        '<strong>Hoje é o ultimo dia para</strong> ler e aceitar os termos de adesão enviado via email. Caso não seja aceito o repasse faltante será transferido e a sua operação com a Hubii será encerrada.',
      last_warning:
        '<strong>Você precisa</strong> ler e aceitar os termos de adesão enviado via email. Sua operação com a Hubii será encerrada a qualquer momento.',
    },
    employee: {
      warning: (date: string) =>
        `<strong>até ${date} um dos proprietários</strong> devem ler e aceitar os termos de adesão enviado no email no proprietário. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta`,
      last_days: (date: string) =>
        `<strong>até ${date} um dos proprietários</strong> devem ler e aceitar os termos de adesão enviado no email no proprietário. As regras de desempenho, pedidos e financeiras praticadas até agora continuam as mesmas. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta.`,
      last_day:
        '<strong>Hoje é o ultimo dia para um dos proprietários</strong> ler e aceitar os termos de adesão enviado no email no proprietário. Caso não seja aceito o repasse faltante será transferido e a operação com a Hubii será encerrada. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta.',
      last_warning:
        '<strong>Um dos proprietários precisa</strong> ler e aceitar os termos de adesão enviado no email no proprietário. Sua operação com a Hubii será encerrada a qualquer momento.',
    },
    support: {
      warning: (date: string) =>
        `<strong>até ${date} um dos proprietários</strong> devem ler e aceitar os termos de adesão enviado no email no proprietário. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta`,
      last_days: (date: string) =>
        `<strong>até ${date} um dos proprietários</strong> devem ler e aceitar os termos de adesão enviado no email no proprietário. As regras de desempenho, pedidos e financeiras praticadas até agora continuam as mesmas. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta.`,
      last_day:
        '<strong>Hoje é o ultimo dia para um dos proprietários</strong> ler e aceitar os termos de adesão enviado no email no proprietário. Caso não seja aceito o repasse faltante será transferido e a operação com a Hubii será encerrada. Veja em Conta > Usuários quem estão cadastrados como proprietários desta conta.',
      last_warning:
        '<strong>Um dos proprietários precisa</strong> ler e aceitar os termos de adesão enviado no email no proprietário. Sua operação com a Hubii será encerrada a qualquer momento.',
    },
  },
}
